<ion-header no-border>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="padding">

  <h5 class="text-center color-dark">
    {{ title }}
  </h5>

  <div class="spacer-10"></div>

  <ng-container *ngIf="mode === 'openHouseActivity'">
    <!-- <ion-button size="small" *ngIf="rawData && rawData.length > 0" mode="ios" fill="outline" (click)="deleteAllKioskLogsForUID()">
      <ion-label>Delete logs past {{ records }} records</ion-label>
    </ion-button> -->
    <div *ngIf="rawData && rawData.length > 0">
      <div class="leadsContainer" *ngFor="let row of rawData">
        <div class="leadsItem">
          Timestamp: {{row.createdAt}}
        </div>
        <div class="leadsItem">
          Listing ID: {{row.listingId}}
        </div>
        <div class="leadsItem">
          Action: {{row.action}}
        </div>
        <div class="leadsItem" *ngIf="row.guestSurveyData && row.guestSurveyData.guest">
          Name: {{row.guestSurveyData.guest.fullName}}
        </div>
        <div class="leadsItem" *ngIf="row.guestSurveyData && row.guestSurveyData.guest">
          Email: {{row.guestSurveyData.guest.email}}
        </div>
        <div class="leadsItem" *ngIf="row.guestSurveyData && row.guestSurveyData.guest">
          Phone: {{row.guestSurveyData.guest.phoneNumber}}
        </div>
        <ng-container *ngIf="row.guestSurveyData && row.guestSurveyData.questionsAnswers">
          <div *ngFor="let q of row.guestSurveyData.questionsAnswers">
            <div class="leadsItem">
              {{q.question}}: {{q.answer}}
            </div>
          </div>
        </ng-container>
        <div class="leadsItem">
          --------------------------------
        </div>
      </div>
    </div>
    <div class="leadsContainer ion-text-center" *ngIf="!rawData || rawData && rawData.length === 0">
      <p>No log data found.</p>
    </div>
  </ng-container>

  <ng-container *ngIf="mode === 'rawleadsLog'">
    <div *ngIf="rawData && rawData.length > 0">
      <div class="leadsContainer" *ngFor="let row of rawData">
        <div class="leadsItem">
          Timestamp: {{ row.createdDateReadable || row.createdDate }}
        </div>
        <div class="leadsItem">
          Listing ID: {{row.listingId}}
        </div>
        <div class="leadsItem">
          Name: {{row.guest.fullName}}
        </div>
        <div class="leadsItem">
          Email: {{row.guest.email}}
        </div>
        <div class="leadsItem">
          Phone: {{row.guest.phoneNumber}}
        </div>
        <div *ngFor="let q of row.questionsAnswers">
          <div class="leadsItem">
            {{q.question}}: {{q.answer}}
          </div>
        </div>
        <div class="leadsItem">
          --------------------------------
        </div>
      </div>
    </div>
    <div class="leadsContainer ion-text-center" *ngIf="!rawData || rawData && rawData.length === 0">
      <p>No raw leads found.</p>
    </div>
  </ng-container>

</ion-content>